import * as squint_core from 'squint-cljs/core.js';
import { h, render } from 'preact';
import { useState } from 'preact/hooks';
import * as dom from './cljdoc.client.dom.jsx';
import * as cljdoc_DOT_client_DOT_dom from './cljdoc.client.dom.jsx';
import * as page from './cljdoc.client.page.jsx';
import * as cljdoc_DOT_client_DOT_page from './cljdoc.client.page.jsx';
var list_icon = function () {
return <svg xmlns="http://www.w3.org/2000/svg" class="w1 h1 mr2" viewBox="0 0 24 24" fill="currentColor"><circle cx="5" cy="6" r="1.5"></circle><circle cx="5" cy="12" r="1.5"></circle><circle cx="5" cy="18" r="1.5"></circle><rect x="9" y="5" width="12" height="2" rx="1"></rect><rect x="9" y="11" width="12" height="2" rx="1"></rect><rect x="9" y="17" width="12" height="2" rx="1"></rect></svg>;

};
var left_chevron_icon = function () {
return <svg xmlns="http://www.w3.org/2000/svg" class="w1 h1 mr2" viewBox="0 0 32 32"><path d="M20 1 L24 5 L14 16 L24 27 L20 31 L6 16 z"></path></svg>;

};
var MobileNav = function () {
const vec___1_10 = useState(null);
const scroll_pos_main_11 = squint_core.nth(vec___1_10, 0, null);
const set_scroll_pos_main_12 = squint_core.nth(vec___1_10, 1, null);
const vec___4_13 = useState(null);
const scroll_pos_nav_14 = squint_core.nth(vec___4_13, 0, null);
const set_scroll_pos_nav_15 = squint_core.nth(vec___4_13, 1, null);
const vec___7_16 = useState(null);
const show_nav_17 = squint_core.nth(vec___7_16, 0, null);
const set_show_nav_18 = squint_core.nth(vec___7_16, 1, null);
const toggle_nav_19 = (function () {
const display_20 = "dn";
const hide_21 = "db";
const main_view_22 = dom.query(".js--main-scroll-view");
const main_sidebar_23 = dom.query(".js--main-sidebar");
const is_nav_shown_QMARK__24 = ((squint_core.truth_(main_view_22)) ? (dom.has_class_QMARK_(main_view_22, display_20)) : (main_view_22));
if (squint_core.truth_(is_nav_shown_QMARK__24)) {
const scroll_pos_25 = window.scrollY;
dom.remove_class(main_view_22, display_20);
if (squint_core.truth_(main_sidebar_23)) {
dom.replace_class(main_sidebar_23, hide_21, display_20)};
window.scrollTo(0, scroll_pos_main_11);
set_show_nav_18(false);
return set_scroll_pos_nav_15(scroll_pos_25);
} else {
const scroll_pos_26 = window.scrollY;
if (squint_core.truth_(main_view_22)) {
dom.add_class(main_view_22, display_20)};
if (squint_core.truth_(main_sidebar_23)) {
dom.add_class(main_sidebar_23, "flex-grow-1");
dom.replace_class(main_sidebar_23, display_20, hide_21)};
window.scrollTo(0, scroll_pos_nav_14);
set_show_nav_18(true);
return set_scroll_pos_main_12(scroll_pos_26);
};

});
return <><div class="bg-light-gray "><button class="outline-0 bw0 bg-transparent w-100 tl pa2 flex items-center" onClick={toggle_nav_19}>{((squint_core.truth_(show_nav_17)) ? (left_chevron_icon()) : (list_icon()))}<span class="dib">{((squint_core.truth_(show_nav_17)) ? ("Back to Content") : ("Tap for Articles & Namespaces"))}</span></button></div></>;

};
var init = function () {
if (squint_core.truth_(page.is_project_doc())) {
const temp__6897__auto___1 = dom.query("[data-id='cljdoc-js--mobile-nav']");
if (squint_core.truth_(temp__6897__auto___1)) {
const mobile_nav_node_2 = temp__6897__auto___1;
return render(h(MobileNav), mobile_nav_node_2);
};
};

};

export { left_chevron_icon, MobileNav, init, list_icon }
